import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { environment } from 'src/environments/environment';

const timesheetAPI = `${environment.api}/timesheet/`;
const usersSelectAPI = `${environment.api}/userSelects/`;

@Injectable({
  providedIn: 'root'
})
export class TimesheetService {
  date: Date | null = null;
  chosenUser: any;
  constructor(private readonly http: HttpClient) {}

  /**
   * Questa API è per richiamare la index di timesheet
   * @param chosenUser id utente
   * @param startWeek settimana che vogliamo visualizzare
   * @param type indica se dobbaimo vedere le ore di scrum o fatturazione
   */
  getTimesheet(chosenUser?: string, startWeek?: any, type?: string) {
    return this.http.get<any>(timesheetAPI + 'index', {
      params: {
        chosen_user: chosenUser || '',
        start_week: startWeek || '',
        type: type || ''
      }
    });
  }

  /**
   * API che serve per modificare le ore in un progetto
   * @param time tempo impostato nel progetto
   * @param projectId id del progetto dove stiamo modificando le ore
   * @param userId id dell'utente che ha modificato le ore
   * @param date data in cui stiamo modificando le ore
   * @param type indica se stiamo modificando le ore di scrum o fatturazione
   */
  saveTimeSheet(
    time: string,
    projectId: number,
    userId: string,
    date: string,
    type?: string
  ) {
    return this.http.post<any>(timesheetAPI + 'store', {
      project_id: projectId,
      user_id: userId,
      date: date,
      time: time,
      type: type
    });
  }

  /**
   * Funzione che serve per salvare una nota in un singilo progetto
   * @param date giorno in cui vogliamo salvare la nota
   * @param note messaggio della nota
   */
  saveNote(date: string, note: string) {
    return this.http.post<any>(timesheetAPI + 'storeNote', {
      date: date,
      note: note
    });
  }

  /**
   * API che serve per mandare una richiesta timesheet per cambio ore
   */
  requestTimesheet(formData: any) {
    return this.http.post<any>(timesheetAPI + 'requestTimesheet', formData);
  }

  /**
   * API che serve per approvare la richiesta timesheet
   */
  confirmRequest(obj: { user_id: string; date: string; projects: any }) {
    return this.http.post<any>(timesheetAPI + 'respondToTimesheetRequest', obj);
  }

  /**
   * API che serve per recuperare tutti gli utenti di timesheet
   * @returns array di utenti
   */
  getUsersTimesheet(search: string) {
    return this.http.get<any>(usersSelectAPI + 'getUserSelectForTimeSheet', {
      params: { q: search }
    });
  }

  /**
   * Ignora un giorno errato nel timesheet
   */
  ignoreDay(userId: string, date: string) {
    return of({ result: { user_id: userId, date } });
  }
}
